import React, { createContext, useContext, useState, useEffect } from 'react';
import es from '../translations/es.json';
import ca from '../translations/ca.json';

const LanguageContext = createContext();

const translations = {
  es,
  ca,
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Obtener idioma guardado en localStorage o usar ES por defecto
    return localStorage.getItem('language') || 'es';
  });

  useEffect(() => {
    // Guardar idioma en localStorage cada vez que cambie
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
